import queryString from 'query-string';
import type { Configuration } from '../..';
import { getDemoLiveAuthHeadersFresh } from '../../demoLive/demoLiveSession';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import type { ApiMetabaseEmbeddedRequest } from './Types';

export class AnalyticsRequester {
  private requester: Requester;

  private readonly baseUrl: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.baseUrl = '/analytics/v1/kpis';
  }

  public getFromMetabaseEmbeddedDashboardApi = async (dashboardId: number): Promise<string> => {
    const emptyRequest: ApiMetabaseEmbeddedRequest = { parameters: {} };

    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/metabase/embed/dashboard/${dashboardId}`,
      method: HttpMethod.POST,
      body: JSON.stringify(emptyRequest),
      // In demo "live mode" this is one of the two routes that reach the real backend, carrying the
      // real JWT of the chosen fleet — the signed URL that comes back is what the iframe loads.
      // Outside the demo this is an empty object and the headers stay those of the normal session.
      // It works because `CobliAxios.request` spreads `requestData.headers` after `getAuthHeaders()`.
      headers: await getDemoLiveAuthHeadersFresh(),
    };
    const { data } = await this.requester.request(requestData);

    return `${data.data}`;
  };

  public getFromMetabaseQueryParams = (request: ApiMetabaseEmbeddedRequest): string => {
    // search_params
    const searchParams = queryString.stringify(request.parameters);

    // hide widget filters
    const parameters = Object.keys(request.parameters);
    const hideParameters = `hide_parameters=${parameters.join(',')}`;

    // style
    const style = 'bordered=false&titled=false';

    return `${searchParams}#${hideParameters}&${style}`;
  };
}

export default AnalyticsRequester;
